<template>
    <div>
        <Title>基础信息</Title>
        <div class="panel">
            <div class="label">项目名称</div>
            <div class="value3">{{ extra.projectName }}</div>

            <div class="label">设计编号</div>
            <div class="value1">{{ extra.designNo }}</div>
            <div class="label">阶段</div>
            <div class="value2">{{ extra.phaseCode }}</div>

            <div class="label">专业</div>
            <div class="value1">{{ extra.majorName }}</div>
            <div class="label">图纸编号</div>
            <div class="value2">{{ extra.resultNo }}</div>

            <div class="label">图纸名称</div>
            <div class="value1">{{ extra.resultName }}</div>
            <div class="label">子项编号</div>
            <div class="value2">{{ extra.subCode }}</div>

            <div class="label">子项名称</div>
            <div class="value1">{{ extra.subName }}</div>
            <div class="label">申请阶段</div>
            <div class="value2">{{ extra.applyStage }}</div>

            <div class="label full-label">替换说明</div>
            <div class="value4">{{ extra.replaceRemark }}</div>

        </div>
        <Title>文件列表</Title>
        <div class="panel">
            <div style="grid-column-start: 1; grid-column-end: 7; padding: 8px; border-right: 1px solid #e8e8e8;">
                <a-table bordered :dataSource="fileList" :pagination="false" row-key="index" size="small">
                    <a-table-column title="原文件名" width="auto">
                        <template slot-scope="text, record">
                            <template v-if="record.oldFile">
                                <a :href="record.oldFile.completePath" target="_blank" @click.prevent="handleFileClick($event, record.oldFile.completePath, record.oldFile.name)">{{ record.oldFile.name }}</a>
                            </template>
                            <template v-else>--</template>
                        </template>
                    </a-table-column>
                    <a-table-column title="原文件类型" width="100">
                        <template slot-scope="text, record">
                            {{ typeLabel(record.oldFile ? record.oldFile.type : '') }}
                        </template>
                    </a-table-column>
                    <a-table-column title="原文件是否签章" width="100">
                        <template slot-scope="text, record">
                            {{ record.oldFile && record.oldFile.isSign ? '是' : '否' }}
                        </template>
                    </a-table-column>
                    <a-table-column title="替换文件" width="150">
                        <template slot-scope="text, record">
                            <template v-if="record.newFile">
                                <a :href="record.newFile.completePath" target="_blank" @click.prevent="handleFileClick($event, record.newFile.completePath, record.newFile.name)">{{ record.newFile.name }}</a>
                            </template>
                            <template v-else>--</template>
                        </template>
                    </a-table-column>
                    <a-table-column title="替换文件类型" width="100">
                        <template slot-scope="text, record">
                            {{ typeLabel(record.newFile ? record.newFile.type : '') }}
                        </template>
                    </a-table-column>
                    <a-table-column title="替换文件是否签章" width="100">
                        <template slot-scope="text, record">
                            {{ record.newFile && record.newFile.isSign ? '是' : '否' }}
                        </template>
                    </a-table-column>
                </a-table>
            </div>
        </div>
        <Padding />
    </div>
</template>

<script>
import { mapState } from "vuex";
import Title from "../Title";
export default {
    components: {
        Title,
    },
    computed: {
        ...mapState("approval", ["detail"]),
        extra() {
            return this.detail.extra ? this.detail.extra : {};
        },
        attachmentTypeOptions() {
            return [
                { value: 'calc', label: '计算书' },
                { value: 'spec', label: '说明书' },
                { value: 'blueprint', label: '图纸' },
                { value: 'text', label: '文本' }
            ]
        },
        fileList() {
            const oldFiles = this.extra.oldFiles || []
            const newFiles = this.extra.newFiles || []
            return oldFiles.map((oldFile, index) => ({
                oldFile,
                newFile: newFiles[index] || null
            }))
        },
    },
    methods: {
        typeLabel(val) {
            const found = this.attachmentTypeOptions.find(o => o.value === val)
            return found ? found.label : (val || '')
        },
        isPdfFile(filename) {
            return filename && filename.toLowerCase().endsWith('.pdf');
        },
        previewPdf(url, filename) {
            const routeUrl = this.$router.resolve({
                path: '/pdf-preview',
                query: { url, title: filename || 'PDF预览' }
            }).href;
            window.open(routeUrl, '_blank');
        },
        deepDecodeURIComponent(str) {
            // 仅当结果中仍含 %25（编码的百分号）时才继续解码：
            // %25 是"还有一层编码未解"的唯一信号；没有 %25 时再解码会破坏
            // URL 中合法的编码字符（如文件名的 %2B、OSS 签名参数的 %2F），导致下载/查看链接失效
            let decoded = str;
            while (decoded.includes('%25')) {
                const prev = decoded;
                try {
                    decoded = decodeURIComponent(decoded);
                } catch (e) {
                    break;
                }
                if (decoded === prev) break;
            }
            return decoded;
        },
        handleFileClick(event, url, filename) {
            event.preventDefault();
            const decodedUrl = this.deepDecodeURIComponent(url);
            if (this.isPdfFile(filename)) {
                this.previewPdf(decodedUrl, filename);
            } else {
                const a = document.createElement('a');
                a.href = decodedUrl;
                a.download = filename || '';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        },
    },
};
</script>

<style lang="less" scoped>
.panel {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    border-top: 1px solid #e8e8e8;

    & > div {
        padding: 8px;
        border-bottom: 1px solid #e8e8e8;
    }

    .label {
        background-color: #fafafa;
        border-right: 1px solid #e8e8e8;
        border-left: 1px solid #e8e8e8;
    }

    .full-label {
        grid-column-start: 1;
        grid-column-end: 2;
    }

    .value1 {
        grid-column-start: 2;
        grid-column-end: 4;
    }

    .value2 {
        grid-column-start: 5;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }

    .value3 {
        grid-column-start: 2;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }

    .value4 {
        grid-column-start: 2;
        grid-column-end: 7;
        border-right: 1px solid #e8e8e8;
    }
}
</style>
